import type { CityConfig } from "../city-template/types";

export const erieCoConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Erie",
  state: "Colorado",
  stateAbbr: "CO",
  slug: "erie-co",
  route: "/cities/erie-co",
  title: "Emergency & Expedited Passport Erie CO | Same-Day Boulder County | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Erie, Colorado — as fast as 24 hours. Same-day courier processing for Erie, Lafayette, Broomfield, Longmont, and all Boulder/Weld County travelers. A+ BBB rated, registered State Dept. courier. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Erie, CO",
  heroSubtitle: "Family trip to Europe with the kids and you just realized the passports are expired? Erie corporate traveler with a last-minute international assignment? We help Erie residents — from Vista Ridge families to Erie Commons professionals to Colliers Hill homeowners — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates typically 30–100% lower than other passport courier resellers. As fast as 24 hours. A+ BBB rated.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Erie%20Colorado%20suburban%20landscape%20with%20new%20residential%20communities%20and%20open%20space%2C%20the%20Rocky%20Mountain%20Front%20Range%20foothills%20in%20the%20background%2C%20modern%20family%20homes%20with%20manicured%20lawns%20in%20Vista%20Ridge%20and%20Erie%20Commons%20neighborhoods%2C%20Colorado%20prairie%20grassland%20meeting%20suburban%20development%2C%20bright%20afternoon%20light%20with%20puffy%20white%20clouds%2C%20professional%20real%20estate%20photography%20style%2C%20no%20visible%20text%20or%20people%2C%20clean%20wide%20angle%20view%20with%20mountain%20backdrop&width=1800&height=700&seq=erie-co-hero-001&orientation=landscape",
  heroImageAlt: "Erie Colorado suburban community with Front Range mountain backdrop and open spaces",
  geoPosition: "40.0503;-105.0500",
  geoPlacename: "Erie, Colorado",
  lastModified: "2026-06-05",
  regionalAgency: {
    name: "Denver Passport Agency",
    address: "3151 S. Vaughn Way, Aurora, CO 80014",
    distance: "Approximately 35 miles southeast via I-25 and I-225 — about 45 minutes",
  },
  nearbyCitiesZips: [
    { name: "Erie", zips: "80514, 80516" },
    { name: "Lafayette", zips: "80026" },
    { name: "Louisville", zips: "80027" },
    { name: "Broomfield", zips: "80020, 80021, 80023, 80038" },
    { name: "Longmont", zips: "80501, 80502, 80503, 80504" },
    { name: "Superior", zips: "80027" },
    { name: "Boulder", zips: "80301, 80302, 80303, 80304, 80305" },
    { name: "Frederick", zips: "80504, 80516, 80530" },
    { name: "Firestone", zips: "80504, 80520" },
    { name: "Dacono", zips: "80514" },
    { name: "Niwot", zips: "80503, 80544" },
    { name: "Westminster", zips: "80020, 80021, 80023, 80030, 80031" },
    { name: "Thornton", zips: "80229, 80233, 80241, 80260, 80602" },
    { name: "Northglenn", zips: "80233, 80234, 80241, 80260" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier service for urgent Erie family vacations and Boulder County international departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved — no need to drive 35 miles to Denver" },
    { icon: "ri-home-line", title: "Family-Focused Service", desc: "Specialized help for Erie families — one of Colorado's fastest-growing family communities" },
    { icon: "ri-mail-send-line", title: "Overnight Shipping", desc: "Prepaid labels from any UPS or FedEx in Erie, Lafayette, or Broomfield" },
  ],
  internalLinks: [
    { name: "Expedited passport in Boulder, CO", route: "/cities/boulder" },
    { name: "Emergency passport help in Broomfield, CO", route: "/cities/broomfield" },
    { name: "Fast passport renewal in Longmont, CO", route: "/cities/longmont" },
    { name: "Urgent passport services for Lafayette and Louisville", route: "/cities/erie-co" },
    { name: "Colorado passport services overview", route: "/states/colorado" },
    { name: "Passport courier services in Frederick and Firestone", route: "/cities/erie-co" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Erie remotely via secure registered courier. Our couriers hand-deliver your documents directly to U.S. Department of State processing facilities. Erie's location — 35 miles from the Denver Passport Agency — makes our courier service especially valuable. Skip the drive down I-25 and let us handle everything.",
  fpcOfficeAddress: "3151 S. Vaughn Way, Aurora, CO 80014",
  fpcOfficeDistance: "Serving all of Erie, Boulder County, and the North I-25 corridor",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Erie and the surrounding Boulder County and Weld County communities. From Vista Ridge and Erie Commons to Colliers Hill and the Erie Air Park, from the new developments along Erie Parkway to the established neighborhoods — we serve every corner of this rapidly growing community.",
  nearbyCitiesIntro: "We serve Erie and all nearby Boulder County and Weld County communities including Lafayette, Louisville, Broomfield, Longmont, Superior, Boulder, Frederick, Firestone, Dacono, and Niwot. We also serve Westminster, Thornton, and Northglenn in the north metro area.",
  howItWorksIntro: "Most Erie travelers complete everything online and ship documents via overnight courier. Our registered couriers handle the State Department delivery — no need to drive 35 miles to Denver on I-25.",
  mistakesIntro: "Erie is one of Colorado's fastest-growing family communities with residents who travel internationally for vacations and business. Here are the most common passport mistakes we see from Erie-area travelers.",
  testimonialsIntro: "Erie travelers — from Vista Ridge families heading to Europe to Erie Commons professionals on international business — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Erie, CO? Here are the most common ones we hear from Boulder County and Weld County travelers.",
  statePageRoute: "/states/colorado",
  statePageName: "Colorado",
  dmvWebsite: "https://dmv.colorado.gov",
  dmvLabel: "Colorado DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive to Denver (45 min via I-25/I-225)", "Subject to availability — no guarantees"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "No Denver drive required — ship from Erie", "Perfect for family vacations and European trips", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Faster than self-service", "Good for planned seasonal travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Erie travelers with immediate departure needs — as fast as 24 hours. Our couriers provide the fastest passport service available without the drive to Denver.",
      bullets: ["24–48 hour turnaround available", "Family vacation and business travel expertise", "Boulder County and DIA departure support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Erie adults with a passport issued within the last 15 years. Skip the post office and let our couriers handle everything.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Erie or Boulder County address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Erie residents — especially families with kids getting their first passports.",
      bullets: ["Acceptance facility scheduling in Erie, Lafayette, or Broomfield", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Erie residents who lost their passport before international travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Erie's many families traveling internationally with kids.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Erie and Boulder County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Erie CO", description: "Urgent passport processing for Erie Colorado travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Erie CO", description: "Fast passport renewal for Erie Colorado residents with a previously-issued passport." },
    { name: "First-Time Passport Erie CO", description: "New passport application services for Erie Colorado residents applying for their first passport." },
    { name: "Child Passport Erie CO", description: "Minor passport services for Erie Colorado families with children under 16." },
  ],
  testimonials: [
    {
      name: "Amanda P.",
      location: "Erie, CO — Vista Ridge",
      rating: 5,
      text: "Family trip to Italy during spring break. Four passports — two renewals and two first-time for our kids. Fast Passport Center handled everything in 6 business days. The family bundle pricing was reasonable and the service was flawless.",
      service: "Family Passport Bundle",
    },
    {
      name: "Brian C.",
      location: "Erie, CO — Erie Commons",
      rating: 5,
      text: "Business trip to Singapore with 5 days notice. My passport was valid but needed pages — Fast Passport Center got me a new passport in 3 days. Shipped from the UPS Store in Lafayette and everything went smoothly.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Heather L.",
      location: "Erie, CO — Colliers Hill",
      rating: 5,
      text: "Lost my passport during a move to Colliers Hill. Had a trip to Mexico booked for the following week. Fast Passport Center replaced it in 48 hours. The document review caught a discrepancy I would have missed.",
      service: "Lost Passport Replacement",
    },
    {
      name: "Kevin R.",
      location: "Erie, CO — Grandview",
      rating: 5,
      text: "College graduation trip to Japan for my daughter. Her passport expired and we had 10 days. Fast Passport Center expedited her renewal in 4 days. Made the trip happen. Amazing service for Erie families.",
      service: "Child Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "erie-co-1",
      name: "Erie Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "150 Wells St",
      city: "Erie",
      state: "CO",
      zip: "80516",
      phone: "(303) 828-9171",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Central Erie, near Erie Community Park",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Erie acceptance facility. Appointments required — book 1–2 weeks in advance. Convenient for all Erie neighborhoods.",
      icon: "ri-mail-line",
    },
    {
      id: "erie-co-2",
      name: "Lafayette Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "603 S Public Rd",
      city: "Lafayette",
      state: "CO",
      zip: "80026",
      phone: "(303) 665-0640",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Lafayette, approximately 5 miles southwest of Erie",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Lafayette and Erie residents. Extended hours compared to the Erie location. Popular with south Erie families.",
      icon: "ri-mail-line",
    },
    {
      id: "erie-co-3",
      name: "Broomfield Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "3001 W 124th Ave",
      city: "Broomfield",
      state: "CO",
      zip: "80020",
      phone: "(303) 469-0719",
      hours: "Mon–Fri: 9:00 AM – 5:00 PM",
      distance: "Broomfield, approximately 10 miles south of Erie",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Largest facility in the area with the most extended hours. Good for after-work appointments. Serves Broomfield and south Erie.",
      icon: "ri-mail-line",
    },
    {
      id: "erie-co-4",
      name: "Longmont Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "201 Coffman St",
      city: "Longmont",
      state: "CO",
      zip: "80501",
      phone: "(303) 776-1120",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Longmont, approximately 12 miles northwest of Erie",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Longmont and north Erie residents. Historic downtown facility with full passport services.",
      icon: "ri-mail-line",
    },
    {
      id: "erie-co-5",
      name: "Boulder County Clerk — Boulder",
      type: "County Clerk Passport Acceptance",
      address: "1750 33rd St",
      city: "Boulder",
      state: "CO",
      zip: "80301",
      phone: "(303) 413-7717",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Boulder, approximately 15 miles west of Erie",
      website: "https://www.bouldercounty.gov/",
      websiteLabel: "Boulder County Clerk",
      notes: "Boulder County clerk passport acceptance with morning hours starting at 8:00 AM. Ideal for Erie residents who work in Boulder.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 45 min drive to Denver via I-25/I-225", fpc: "No — ship from Erie" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "I-25 Rush Hour", agency: "Heavy congestion — unpredictable timing", fpc: "No driving needed — courier handles it" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until School Breaks",
      description: "Erie families often book international trips during spring break, summer, and winter holidays. These periods coincide with peak passport demand. Start expedited service at least 4 weeks before your family trip.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photos for Kids",
      description: "Children's passport photos have strict requirements — eyes must be open, no smiling (neutral expression), both ears visible. Local photo services sometimes overlook these specifications for kids.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Not Booking Acceptance Facilities Early Enough",
      description: "The Erie Post Office is small and appointments fill quickly. Book 2 weeks ahead, especially during school break periods when families are all applying simultaneously.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Both Parents at Appointment",
      description: "For child passports, both parents must appear at the acceptance facility. Many Erie families arrive with only one parent and get turned away. Plan ahead or arrange notarized consent.",
    },
    {
      icon: "ri-global-line",
      title: "Not Checking Passport Validity for Each Family Member",
      description: "It's common for one family member's passport to be expired while others are valid. Check every passport the moment you book international travel — kids' passports expire after only 5 years.",
    },
    {
      icon: "ri-flight-takeoff-line",
      title: "Booking Flights Before Having Passports",
      description: "Erie families sometimes book international flights before realizing passports are expired or don't have enough validity. Always verify passport status BEFORE purchasing non-refundable tickets.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from your home in Erie or office in Boulder." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx in Erie, Lafayette, or Broomfield." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — catching errors before they cause rejections." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier submits to State Department facilities — no I-25 drive to Denver required." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Erie address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Erie, CO?", a: "Fast Passport Center offers emergency passport processing in Erie, Colorado in as little as 24–48 hours. Our registered couriers hand-deliver your documents to U.S. Department of State facilities — no need to make the 35-mile drive on I-25 to the Denver Passport Agency." },
    { q: "Does Erie have its own passport agency?", a: "No — Erie does not have a regional passport agency. The nearest is the Denver Passport Agency (35 miles southeast via I-25 and I-225). Fast Passport Center's courier service means Erie residents never need to make the drive." },
    { q: "Do you help Erie families with multiple passports?", a: "Absolutely. Fast Passport Center specializes in helping Erie families — one of Colorado's fastest-growing family communities. We can process multiple passports simultaneously for parents and children, coordinating everything to match your family travel timeline." },
    { q: "What if I live in the Weld County portion of Erie?", a: "No problem. Erie straddles both Boulder and Weld counties, but our service works identically regardless of which county your address falls in. We serve all Erie residents — Boulder County side, Weld County side, and all neighborhoods in between." },
    { q: "Can you help with passports for Lafayette, Louisville, or Broomfield residents?", a: "Yes. Fast Passport Center serves all Boulder County communities including Lafayette, Louisville, Superior, Broomfield, and Boulder itself. Our service is identical across the entire area — ship your documents and we handle the rest." },
    { q: "How much does an expedited passport cost in Erie, CO?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific travel timeline." },
    { q: "Where can I get passport photos in Erie?", a: "Walgreens (2998 Baseline Rd in Boulder and 1200 South Hover in Longmont), CVS (1840 Folsom St in Boulder), and the UPS Store (555 W South Boulder Rd in Lafayette) offer passport photo services. The King Soopers on 4800 Baseline in Boulder also provides photos." },
    { q: "What's the closest major airport for international flights from Erie?", a: "Denver International Airport (DIA) is the primary international airport for Erie travelers — approximately 40 miles southeast via I-25 and E-470. DIA offers nonstop flights to Europe, Asia, Mexico, Canada, and domestic destinations. Allow 45–55 minutes for the drive." },
  ],
  photoLocations: [
    { name: "UPS Store — Lafayette", address: "555 W South Boulder Rd, Lafayette, CO 80026", hours: "Mon–Fri: 8AM–6PM, Sat: 9AM–3PM", website: "https://www.theupsstore.com" },
    { name: "Walgreens — Boulder (Baseline)", address: "2998 Baseline Rd, Boulder, CO 80303", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com" },
    { name: "Walgreens — Longmont", address: "1200 S Hover St, Longmont, CO 80501", hours: "Mon–Sun: 8AM–10PM", website: "https://www.walgreens.com" },
    { name: "CVS Pharmacy — Boulder", address: "1840 Folsom St, Boulder, CO 80302", hours: "Mon–Sun: 8AM–9PM", website: "https://www.cvs.com" },
    { name: "King Soopers — Boulder (Baseline)", address: "4800 Baseline Rd, Boulder, CO 80303", hours: "Mon–Sun: 6AM–11PM", website: "https://www.kingsoopers.com" },
  ],
  dmvLocations: [
    { name: "DMV — Boulder (Boulder County)", address: "2850 Iris Ave, Boulder, CO 80304", hours: "Mon–Fri: 8AM–5PM", note: "Full-service DMV for Boulder County residents. REAL ID and driver's license renewals. Most convenient for Erie residents on the Boulder County side.", featured: true },
    { name: "DMV — Longmont (Boulder County)", address: "529 Coffman St, Longmont, CO 80501", hours: "Mon–Fri: 8AM–5PM", note: "Alternative Boulder County DMV location. Convenient for Erie residents closer to Longmont.", featured: false },
    { name: "DMV — Greeley (Weld County)", address: "2320 Reservoir Rd, Greeley, CO 80631", hours: "Mon–Fri: 8AM–5PM", note: "For Erie residents on the Weld County side. REAL ID processing available.", featured: false },
  ],
  airports: [
    {
      code: "DEN",
      name: "Denver International Airport",
      distance: "40 miles southeast of Erie via I-25 and E-470",
      address: "8500 Peña Blvd, Denver, CO 80249",
      note: "Colorado's primary international airport with nonstop flights to Europe, Asia, Mexico, Canada, and domestic destinations. Approximately 45–55 minutes from Erie.",
      flightUrl: "https://www.flydenver.com/",
      flightLabel: "DEN Flight Info",
      featured: true,
    },
    {
      code: "BDU",
      name: "Boulder Municipal Airport",
      distance: "15 miles west of Erie via Arapahoe Road",
      address: "3327 Airport Rd, Boulder, CO 80301",
      note: "General aviation airport serving Boulder and the surrounding area. No commercial flights. Convenient for private aviation travelers.",
      flightUrl: "https://bouldercolorado.gov/",
      flightLabel: "BDU Info",
      featured: false,
    },
  ],
};